import { render, staticRenderFns } from "./TenuredGenBar.vue?vue&type=template&id=79a45eca&"
import script from "./TenuredGenBar.vue?vue&type=script&lang=js&"
export * from "./TenuredGenBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports